// extracted by mini-css-extract-plugin
module.exports = {"heading":"_1U1v-","checklistWrap":"_2M5u6","checklist":"_3dV9g","options":"_14vUC","rightCol":"_14Twn"};